import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import React from 'react';

const LoginBrandsCarrusel = () => {
  const images = [
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/LOREAL-2-olc0w78u74uw925a54b314xax6qvtr6no7al4gjjx2.png', alt: 'LOREAL' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/VOLKSWAGEN-2-1-olwh6nz4yw7ke61006nljtmaohr7pz0gb0sqz1566u.png', alt: 'VOLKSWAGEN' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/TENARIS-TECHINT-2-1-olwh6l5mee3pfc53gnfpucbwwc542vp9amuaj79cpi.png', alt: 'TENARIS-TECHINT' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/PAOLINI-GURAS-2-1-olwh6fil9dvzhodadkzyfdr5c0wwsp2v9uxdnjhpqu.png', alt: 'PAOLINI-GURAS' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/INFOBAE-2-1-olwh6647d1j49kqxwgxoqg4je678nq1jwkeiurvnh2.png', alt: 'INFOBAE' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/AA2000-2-2-olwh5sygpd13r1a21b8wrjg32s03nylb6r9q4wf5w6.png', alt: 'AA2000' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/BANCO-GALICIA-2-2-olwh5vrz9v4ypv5ykugsh0qguxm7b1wi7586kqazdi.png', alt: 'BANCO GALICIA' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/COLUMNAS-1-2-1-olwh5xnnnj7jd3389va1m09e1pcxqg3yvej5ja8712.png', alt: 'COLUMNAS' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/CRUSA-2-1-olwh60h681bebwz4tehxbhjrtuz1djf5vshlz440ie.png', alt: 'CRUSA' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/DISCOVERY-2-1-olwh63aosjf9aqv1cxpt0yu5m0l50mqcw6g2exztzq.png', alt: 'DISCOVERY' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/PREAR-2-1-olwh6j9y0q14s47trmmgpcszpkednhhsmdjbknc51y.png', alt: 'PREAR' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/COPIMEX-LISUAL-pvecifnijksf9f8b16ycpz610zcypwk10ew5syowba.jpg', alt: 'COPIMEX + LISUAL' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/CRIBA-Y-LISUAL-pveciglcqetpl16xvpczagxhmd8bxlnrcjjna8ni52.jpg', alt: 'CRIBA Y LISUAL' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/VIZORA-Y-LISUAL-pvecihj6x8uzwn5kq7rluyoy7r3p5arhoo74rim3yu.jpg', alt: 'VIZORA Y LISUAL' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/ROSBACO-LISUAL-pvecihj6x8uzwn5kq7rluyoy7r3p5arhoo74rim3yu.jpg', alt: 'ROSBACO + LISUAL' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/ZONIS-Y-LISUAL-pveciih142wa8947kq68fgget4z2czv80sum8skpsm.jpg', alt: 'ZONIS Y LISUAL' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/CONCRETNOR-pveciih142wa8947kq68fgget4z2czv80sum8skpsm.jpg', alt: 'CONCRETNOR' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/NEMOVI-Y-LISUAL-pvecikcphqyuvh1h9qzhkfzbzwpsse2op25l7chxg6.jpg', alt: 'NEMOVI Y LISUAL' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/COSAPI-pvecilajol05730449e44xqslal6036f16t2omgj9y.jpg', alt: 'COSAPI' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/ESUCO-pvecim8dvf1fioyqyrsqpfi96ogj7sa5dbgk5wf53q.jpg', alt: 'ESUCO' },
    { src: 'https://lisual.com/wp-content/uploads/elementor/thumbs/PANEDILE-pvecim8dvf1fioyqyrsqpfi96ogj7sa5dbgk5wf53q.jpg', alt: 'PANEDILE' }
  ];

  return (
    <section className="py-12 sm:py-20 bg-gray-100">
      <div className="container mx-auto py-6 px-4">
        <div className="flex flex-wrap items-center -mx-4">
          <div className="w-full md:w-1/2 px-4">
            <h3 className="text-4xl font-bold mb-4">Marcas que confían en Lisual</h3>
            <p className="text-lg mt-4">
              Hemos tenido el privilegio de colaborar con grandes empresas que confían en nuestras soluciones para sus proyectos más ambiciosos. 
              Te mostramos algunas de las marcas que nos han elegido.
            </p>
          </div>
          <div className="w-full md:w-1/2 px-4">
            <div className="w-full">
              <Swiper
                modules={[Autoplay]}
                spaceBetween={20}
                slidesPerView={1}
                breakpoints={{
                  640: {
                    slidesPerView: 2,
                  },
                  768: {
                    slidesPerView: 3,
                  },
                  1024: {
                    slidesPerView: 4,
                  },
                }}
                loop={true}
                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false,
                }}
                pagination={{ clickable: true }}
                className="mySwiper mt-10"
              >
                {images.map((image, index) => (
                  <SwiperSlide key={index}>
                    <div className="w-full px-2 flex items-center justify-center">
                      <img src={image.src} alt={image.alt} className="max-h-12 sm:max-h-16 md:max-h-20 w-auto object-contain" />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoginBrandsCarrusel;